import axios from "axios";
import { toast } from "react-toastify";
import { API_BASE_PATH } from "../environment";

const BASE_URL = `${API_BASE_PATH}`;

const getAuthHeaders = () => {
  const token = localStorage.getItem("authToken") || "";
  return {
    Authorization: token,
    Accept: "application/json",
    "Content-Type": "application/x-www-form-urlencoded",
  };
};

const showAxiosError = (error: any, fallback: string) => {
  const detail = error?.response?.data?.detail || error?.message || fallback;
  toast.error(detail);
};

export const exportLeads = async ({
  fields,
  export_type,
  filter_type,
  filter_id,
  year,
  month,
   branch_city, 
   lead_status,
}: {
  fields: string;
  export_type: "excel" | "pdf";
  filter_type: string;
  filter_id: string;
  year: number;
  month?: number;
  branch_city: string;
  lead_status?:string;
}) => {
  try {
    const res = await axios.get(`${BASE_URL}/export/leads`, {
      headers: getAuthHeaders(),
      params: {
        fields,
        export_type,
        filter_type,
        filter_id,
        year,
        month,
        branch_city, 
        lead_status,
      },
      responseType: "blob", // required for downloading files
    });
    const blob = new Blob([res.data], { type: res.headers["content-type"] });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `leads_export.${export_type === "excel" ? "xlsx" : "pdf"}`;
    a.click();
    window.URL.revokeObjectURL(url);
    toast.success("Leads report downloaded successfully");
  } catch (error) {
    showAxiosError(error, "Failed to export leads");
    throw error;
  }
};
